<template>
  <div v-show="dialogVisible" class="Countryselect">
    <div class="mask" @click="dialogVisible = false"></div>
    <div class="Countryselect-inner">
      <p class="title plr1">选择国家/地区</p>
      <div class="top">
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAbP0lEQVR4Xu1dCZhlVXGuuq9nOrMQTWJcvkAUyACiKAKKAtN967yGRmQNMioREHHYxA1ExRhlG7YB2QRkZ1AWFeMyi/T0vFu3ewaICglGRgUii2KMAi4og9Pd71a+wtfYvL73Lfdtdznn+973eqbPUvXX+fvcuuecKgRbLAIWgUgE0GJjEbAIRCNgCWJnh0WgBgKWIHZ6WAQsQewcsAjEQ8CuIPFws61ygoAlSE4MbdWMh4AlSDzcbKucIGAJkhNDWzXjIWAJEg832yonCFiC5MTQVs14CFiCxMPNtsoJApYgDRp65cqV8xcuXDjfcZx55XJ5fqFQmK/f2hwRn+3r69s0NTW1afPmzZv6+/s3EdGfGuzaVkswApYgM4zDzC8Tke0BYHvHcbav/LyD/rtZGyLiJhF5EAD08xP9dhznwWeeeebBAw44YFOz/dn6vUEg1wQZGxt7UxAEewLA9GerLpnhfgDwC4XChsnJyXuLxeLjXRrXDtMkArkiCDPvICL7IOJeAPA2ANiySbw6Vf1+Efk+Io5PTEysHR4e/nWnBrL9NodA5gnCzDsDwDAi7iMipjl4elL7DwAwgohry+XyWru69MQGLwyaSYKMjIy8fO7cuScoMSorRW9Rjj/6lJJFRL5tjLkmfje2ZVwEMkWQDRs2bDE5OXkiACg5Xh0XlOp2iPgjEfkFADwrIupgP6tvrvRnx3FARBYAwAJEfP678u9tAeA17ZIBAO4TkWssUdqIaANdZYIgzNwnIiciohJD3zrFKoj4a/UFAOABAPihiDzw1FNPPbBkyZJynA5HRkYW9Pf37ygirxORHQHgdYi4CwC8Mk5/lTaWKC2A12zT1BOEmY8BgJMAQH2NZsofAUDfJunnvnK5fPfQ0NBDzXQQt+66deu2cRxnNwDYDRGf/waALZrs7z4AuIqIrm+yna3eBAKpJYjv+28XkY8BwN5N6PscAKxyHGfV5OTk6qGhoaebaNuxqpX9lwMR8UAAOKjJgUYR8WLXdb/TZDtbvQEEUkeQylupjwLAUQ3oN11lFQCsVnIQ0RNNtOt6Vc/zdFPyoApZdH+m0bICAC4hIl0RbWkTAqkhiDrgExMTpyGikmNeA/o/LSI3A8AKY8wPGqifuCqe5w07jnOkiBzeoHDPicglk5OTy4aHh59tsI2tVgOBVBCEmV0AOA8Adq9nTUR8aJoYSV8t6uky/XtmVl/lyCAIjkLEv67XTkTuAoBTjDHfrVfX/r42AoknCDOfUiFHXy1VEPEREVne39+/Yo899lBfI3NlbGxs6yAIjgSA0wCgv5aCIvJ7RDzFOvGtTYPEEmR0dPQfC4XCeYj4nnoqisi1hULhrMHBwZ/Xq5uF3/u+/2YRUZIc0oA+l7iuewoiBg3UtVWqEEgkQUql0iGIqOTYro7FNgLAWUT0lTxalpk/AACfAgDdlKxV1k1NTZ289957/zCPOLWic+II4vv+YSLy1QaUurRcLp+VlFe1DcjbkSrj4+Ovmpqa0pcXH6ozwGNBEBxXLBbXdkSQjHaaKII0Qg51wgHgM67rfi2jNomllmIHAGeLSOSqKyIThULh6MHBwVtjDZLDRokhSCPk0Fe2So6svJ1q93xjZj2+f3YDe0THE9HV7R4/i/0lgiClUmmp4zi1TqvqjrcS44tZNEK7dWLm4ytE+bsafX+ciC5q99hZ66/nBGHmzwHA6TWAvUtEPpjWzb5eTRjP896IiLfoAckaMpxORGf0SsY0jNtTgtQjhzrriHgcEf0uDWAmTcaxsbFFQRB8ow5JPmD3SqIt1zOC1CMHAFxHREuTNunSJs/DDz/c/8QTT+jJ38iVBBGX2Jce4ZbtCUGY+ZOV3fFQqRDx87q5lbbJmGR5mVnvuFiSNGmkrhPE9/2lejPOPhc3aak2VPc8bwwRB6K6sivJbGS6ShDdIXcc599r2PoOItL3+bZ0CAFm/q9al8vK5bIZGhriDg2fum67RpDK2Sq93BO6kYWInuu6xdQhmDKBr7766jmLFi36CSJuEyY6Iq7X6C9EpAEjcl+6RhDP826tcfDwHiLaI/fW6BIAlVPBehT+78OGFJFzjTGf7pI4iR6mKwSpHFm/MAKJ+wuFwn4DAwO/TDRSGRPO9/3FIjIadWweEfez13gBOk6QymUnNUTYfQ699Ve0m4C9YV+pVDrCcRy9dRlW7p0zZ47Za6+9NJBdbktHCVKJU6XkiLoJeII9PtLbucfMywHg4xFS6B13DYyR29JRgniedw4i6sWesLKCiN6XW+QTpLjv+xq9cZ8If2R/Y4wGvMhl6RhBKtFH7g4LsFC5N160p3KTMefGx8ffoHGAAeAVIRLdAwADeX2r1UmC3BR17NpuSCWDGDOlqOOP5PZQY0cIUgnqtiZiGlxKRBq6x5aEIcDMl1eiVFZLNqU78K7r6mqSq9IRgjCzLtdhEQ83lsvlwbxfk03qDBsbG9sqCAINGRSWSGg1Ee2fVNk7JVfbCVKJlXtdhMDvzmuAhU4ZsN39MrPGOdaVZFYJguDYYrF4bbvHTHJ/bSWIRlkHAI2OPiuQtIbmMcYcm2QwrGx/RsD3/bUiEvYE8B9EpJm5clPaShDP8z6MiJdWo6dB3RDRzUvcqrTPnnXr1u1dKBSiop8cQURfTruOjcrfNoJUNgW/F5Gfw24INmqRhNRjZn1M1tQS1YWJKA2p7NqCZNsIEnUJSvc85s6du3NWw4G2xQoJ7KRyVms8TDQReacx5usJFLvtIrWFIJWcgLp6hKU902gky9ouue2w4wgws95nPzjkkXmN67rv6LgACRigLQSpcb9cw/XsbHfME2DpGCIws5JDSTKriMhb8xA9vl0E0SMls95uiMjFxpiTY9jGNkkIAsysj1mLQ8TJxe56ywSpnLnSa5xhf2V2tkfZEzLTY4pRY1/ru0T01pjdpqZZOwgSFaFE050dkBokrKChCDDzSwFA4yHPun2Yh8eslgni+35J7zCHoGtf7WaEdJ7n3YCIR+fxMaslgjCz5iT/cQhwmuFpO+ucZ4Mhnucdioh3hGiT+ceslggStXMOAF8joiXZmB5WizVr1vTPmzfvwbDX+IVCYdeBgYH/zCpKLRGEmW8DgHdXg+M4zlGDg4NRd52zimWm9fI87wpEPLFaSRH5pDHmgqwq3ypBHgWA11SB84dyuby1PdKerSkTdccHEde6rjucLW3/ok1sgjDz6wEgLOddrs7qZHViVOvFzAtF5BfVaahFJJg7d+5Lsxr9JDZBSqXS0Y7j3BCy5C43xnwiLxMnT3oy850AELZaHEZEYU586uGJTRBmvhEAZkUlEZF3GWMaScKZevDypkDUkSIRud4Yoxl3M1daIUiY/wHlcnnboaGhRzKHlFUISqXSHo7j6JXc6rKRiPSRO3MlFkGY+WUA8GQIGv9HRK/KHEpWoRcQ8Dzv99V+CACUiSgscmbqkYtFEM/z9kTEDSHa5/Jif+pnQRMKMPN3AGDf6iZ9fX3bL168WI+kZKrEJcj7EfH6ECTOJ6JPZQohq8yLEPA870pEPKEaFhE52BjzrazBFYsgvu+fLyJhb6reS0SaWdWWjCLAzBrHV+P5VpfTiOi8rKkdiyDM/E0AOCjkr4g93p61GVKlT9S5LBG52RhzVNbUj0uQnwDA9tVgPPnkk31LliwpZw0kq89fECiVSrs4jqNZc6vLeiKKzH+YVgzjEkSqFUbEH7muWytpfVoxsnLPQGDVqlV/s2DBgt+EgHIfEe2WNbCaJsjKlSvnL1y48NkQIEaJKDSEftZAy7s+zDwBAHOqcPgxEe2YNWyaJkiNPZBvEtEhWQPI6jMbAWb+LQDoTcOZ5XEiqj64mnr4miZIJcDxz0Ic9FuNMf+SekSsAnURYOYnAOAfqio+RUShSUHrdpjgCk0TxPO87RFRnfQXFRt7N8FWbrNozKwbgotmdisim4wxC9o8VM+7a5ogY2NjbwqCIOwGWe7z2fXcml0SgJk1is2sAOVE1PR86pLIsYdpWqGoYyYico4x5l9jS2IbpgYBz/PuQsRZee0tQQAgiiCIeI7rupYgqZnm8QW1BKmBXY1AcTa1Wvw5l6qWzHw/ALyxWmi7ggDA+vXrt5uamtIIF9XlOiJamipLW2FjIcDMDwPAP1mChMDHzFsCwM+rf4WIt7mue3gsxG2jVCHAzP8LALPu/dgVBADuvPPOv+3v79eo7S8qiPht13VnHWBMleWtsA0h4Pv+70Xkr+0KEr6C/BUAaOTE6lIioqGGELaVUo0AM08BQKFKiV8R0StTrViI8E2/5tU+fN9/VkTmV/X3GBFtnTWArD4vRoCZlQS/DHmC+J7rurtnDa9YBGFm3Sh8UzUYExMTC4eHh8MOMmYNt9zqw8ya8uCeEADuIKLDsgZMXIKEhhxFxLe4rqtpoG3JKALMrKFm1f7V5SIi0tuGmSpxCfI5ADg9BImjieimTCFklXkRAsysMQfOrYZFRD5ijLksa3DFJUjoXxERsVEVszZDqvRh5qsA4PgQgtigDdOgRB1YFJE1xphcZD/NOA8i1asR9mfbxYsXZy5gYKwVpMatQhs4LuPMiQgc9wQRbZVF1WMRRIGIOvJsQ49mcZr8WacaoUczmzCpFYJcDAAfDXkWtcGrM8qRGsGrTzbG6HzIXIlNkPHx8UPL5fKskPfWUc/cHHlBoaj0B0EQ7F4sFr+XRc1jE6RUKr3acZzHQkCxCXQyOFOiEugAQGb9DzVjbILU8EP+AADbENFTGZwnuVXJ87z9EHF1CAC3E9F7sgpMSwTxPO8aRJx1B0REjjHGzMo+lVUQ86AXM38RAI4L8TmPM8Zck1UMWiIIM78XAL4UAs63iOjgrIKWN71GR0dfMmfOnB+LyKw7II7jbDc4OKgXqDJZWiLIyMjIy+fOnfs/ALBFyF+WHYwxYTcPMwlklpXyff8IDU4douMGIlqcZd1bIkjFD/kaALwzhCCZzp+d5UlRrZvneXcg4qEhNj7LGPPZLGPRMkF8318qImHPoHcR0V5ZBi8Puq1fv36bqakpDRRYHYsXENG4rstZxqFlglRe9+pj1qwcdSKyrzFmJMsAZl03ZtZQTmeH6PkAEe2Udf1bJkjlMWsVAMw6pIiIt7qua+P1pnQW3X333fMmJibuF5HtQlT4DBEtS6lqDYvdFoJ4nncsIl4dMeqbiejehiWyFRODADPrsXY93l5dnguCYKdisfjTxAjbIUHaQpDKKqIk2LVaTkS83HXdD3dIftttBxHwff9uEXlbiE1vdF33/R0cOjFdt40gUauIiDxTKBR2HhwcfDQxWltB6iLg+/5hIvLVsIqO4wwPDg6urdtJBiq0jSC1VhG9nktEZ2QAr9yowMwrAWD/kNVj3HXdwbwA0VaC1PBFNiPiYhvQIR3TqsYJCXAc55jBwcHcHCNqK0HqrCLfIKJ/TscUya+Ua9as6Z8/f776HruEoLCKiA7IEzqdIMgxAHBdBIhLiSjqd3nCPbG6RkUtUYFFxDXGjCVW+A4I1naCVFYRdeD2DpH3p4VCYfHAwMCsyHwd0M122SQCd91117YTExMaFC4s12AuM4h1hCC+779dI5yE2UdELjfG2Ne+TU7eblT3PO8KRDwxZKzHgyDYs1gs/qIbciRpjI4QpLKKaAC5o8KURcQlruvqIUdbEoJAqVQ6wnGcsBO7KuFJRHRFQkTtqhidJIgmebwbAOZVa4SID4lIkYg0nbAtPUZgfHz8DeVyWR+LXxEiymoimvW6t8cid234jhFENfA87xxEPC1CmxVE9L6uaWoHikTA9/0REdknpMIUIg64rhsWrDoXiHaUICMjIwvmzJkzgoh7RqB5AhHpVU5beoQAMy8HgKig07nf4O0oQSqriOaMUJK8JGQOPK2PWsaYH/RofuR62Dp+h64aA0SkyXJyWzpOEEWWmWvtjWx0HOeQLN9rTuLsWrdu3d6FQiHyPJWI7G+MCYtikkR1OiZTVwhSIUloJMaKZhu33HLLXRctWrS5Y5rajl9AICr4+AyIziOiKN8xV0h2jSAi4qgzCABReQw3EtHrc4V+D5QdGxvbKgiCn9UY+stEdEQPREvkkF0jiGo/Ojq6U19f37cB4DURaFiSdHCa1IjKPz1qCQAOJqI/dlCMVHXdVYIoMqVSaR9EXImIc8OQEpFxY0xujlN3a7ZobKu+vr7f1Rhvo0anISIN0GBLBYGuE0THHRsbOzwIgltqWOH+hx566C3HHXfcpLVU6wiMjY3tFATBf0f1JCK/AYAlxhhdQWyZgUBPCKLjM7OGsYzcAxGRRwqFwpC9idjafPU87x2IqEE1apXM5vdoDb0Wg1e3OjgznwIAF9bo50kNWOa67vpWx8pj+1rXZqvxQMSvuq77rjziVEvnnq0g00JFJWWZIfTmIAiWFovFsBjA1p4RCNTZBIzC7StEpAlabakg0HOCVB63am0kThvrQiI61VquPgJ1jo/U68CSJAk+SLWVGnkcQMS1juOcOjAwEOlw1rN+ln+vp3KDIFgecfBwWvWn9RwpABxWA4tM5/xoZg4kYgWZFrgRkgDAr4IgONU+cr3YzJVHKj14GHZk/fnKiPhDAPiIxtP1ff8rIrIkarKIyG3GmMObmUxZrJsogijADZJEq37BcZwLBgcHf55FwzSqk16T3bx588kRNwFf6EZE1gZB8KGhoaGHpv+TmW8HgEjH3IaO7fFbrKhJsG7dOurr6ztDROrlnlByXEBEX2h0QmWlnkYfmTdv3scA4OSIO+QzVb1pYmLipOHh4Wer9a9HEhG51RiT2/jKiVtBZvx16xORM2tcuHrB1og4OjU1tXxoaGg0KwSopYfGrULEj0WE5nlRUxE51xjz6Tr93QYAtd5e3UJEmk0sdyWxBJnhl2gAiDMBYLcGrHM9Iq7I6r5J5fHzyLCIhyHY3CMiyxo9su553q2IWCsZZy4PMSaeIGr4DRs2bDE5Oakk+WgDJNEq3wQAvdKr36kumoJg8+bNRyHikWGBpEOU0wtOms9jWbOXnXzfv0VEIh1zRPyS67pK0NyUVBBk2hqVYxOa0GVWxPEIi+kO/AoA+DoR1TqolziDVzI7vadCjLD8HGEyr0bEZa3cIfc87xZEjCSJiHzJGJMbkqSKIDojmFkzWSlJPhOW1Spipj8pInoeafWf/vSnVfvtt18iL2ZVsskeGATBQYh4YFjaswj9HgeA5e0KzcPMXwaASMccEW92XTc0pFPi/tK0KFDqCDLDN3mbiChRZmW2qoPJ4yKy2nGcVSKyvtd3H+699975zzzzjKuE0E9YquU6+lwSBMGF7Q7qxsx6tKeWY56LqDSpJcj0pCmVSksdx9FkLm9t9o+F5i5BRA1OcE8QBKPFYlHjeHW8eJ63q0a7BwC99+ICwEtjDKoEv7CTsXJ9379ZRGrdLryJiI6OIXtqmqSeINNIV0L2K1EoLvoVwmhk80cR8RH91s9zzz336P777//bZvpl5ldWbk7q7Un9vLryrUSOQ4jnh0fEcX1T160UBJ7n3YyIuSVJZggyw5E/VFcUEdmvmQndQF29vKUbbfrZpN8iot86aRcAwPMf/VlE9OdCA302WuU5RLxdP73I7OT7/goRiXTMReRGY0wmU7JljiAziLI7Iu4LAG8HAI3NlcbyAADcHgTB7b1OmMnMkbGWK38kbnBdV09lZ6pkliAzreR5XprIskFE2HEc1kOFSZptzHwjAESGixWRG4wxmSJJLggyc5KNj4/vMjU1NeQ4TjEIgiFEdHo8CfUVre56c6FQ4KQH0KtHEgC4nog+0GNM2zZ87ggyE7nKDv2wiOyLiOo879Bm3yHMUI/poWVE1JcB3yei+9tmzS515HneDYhY6+3VdUS0tEvidHSYXBMkDNn169dvNzk5+VpEfK2I6PfWADB/xked8PmIqP8XVX6FiLrfogHaXvhGxB8QkRIk9cX3/etFJNIxR8RrXdc9Nu2KWoKk3YI9lN/zPD0cGkkSEbnWGJNqkliC9HCCZWFoZtakrJGOOSJe47quhnhKZbEESaXZkiU0M18LALUc86uJ6PhkSd2YNJYgjeFka9VBwPf9a0SklmP+RSI6IW1AWoKkzWIJltfzvGsQMVMksQRJ8IRLo2i+718tIpGOuYhcZYwJSzWdSHUtQRJplnQLxcwacznSMUfEK13X/WAatLQESYOVUigjM18FAJGOuYhcaYxJPEksQVI4+dIicj2SAMAVRHRSkvWxBEmydTIgm+d5VyJirbdXXyCiDyVVVUuQpFomQ3L5vn+FiEQ65oh4ueu6H06iypYgSbRKBmXyPO+KWuFRReRyY0ziSGIJksHJmFSVmFlDxEY65oh4meu6H0mS/JYgSbJGDmRh5ssBoJZjfikRNRogsOOIWYJ0HGI7QDUCvu9fJiK1HPNLiEgDc/e8WIL03AT5FMDzvMsQMfEksQTJ5/xMhNa+718qIpGOuYhcbIzR9A49K5YgPYPeDqwIMPMlmvUqCg1E/LzrupoNuSfFEqQnsNtBZyLAzBfXidx/ERF9vBeoWYL0AnU75iwEkkoSSxA7WRODgOd5n9fMWTUE6noqcEuQxEwPK4gi4Pv+RSIS6Zgj4nLXdT/RLbQsQbqFtB2nYQSY+UIAiHTMRWS5MaYrJLEEadhstmI3EWiAJBcYYz7ZaZksQTqNsO0/NgLMvBwAar29Op+IPhV7gAYaWoI0AJKt0jsEfN+/QEROrSHBeUR0WqcktATpFLK237Yh4HneBYjYE5JYgrTNjLajTiLged75iBjpmIvIucaYT7dbBkuQdiNq++sYAsx8HgBEOuaIeI7ruprYtW3FEqRtUNqOuoEAM58LALUc82VEpCnC21IsQdoCo+2kmwh0kySWIN20rB2rbQh4nncOItZ6e3U2Ef1bqwNagrSKoG3fMwR8318mIpGOOSKe5bruZ1sR0BKkFfRs254jwMxnA0CkY46IZ7qu+7m4glqCxEXOtksMAvVIIiJnGmNikcQSJDFmtoK0ggAznwUAtd5enUFEpzc7hiVIs4jZ+olFwPf9M0UkyjHfWCgUlgwMDPyoGQUsQZpBy9ZNPAK+758hItWOeSxyqLKWIIk3uRWwWQQ8zzsDEadJEpscliDNIm/rpwYBZlZ/451xHqtmKmlXkNSY3AraLALj4+M7NutzVI9hCdIs6rZ+rhCwBMmVua2yzSJgCdIsYrZ+rhCwBMmVua2yzSJgCdIsYrZ+rhCwBMmVua2yzSJgCdIsYrZ+rhCwBMmVua2yzSJgCdIsYrZ+rhCwBMmVua2yzSJgCdIsYrZ+rhCwBMmVua2yzSLw/5+3pVBQSeFyAAAAAElFTkSuQmCC"
          alt=""
        />
        <input
          v-model="CountryName"
          type="text"
          class="input"
          placeholder="请输入国家/地区名称"
          @input="check"
        />
      </div>
      <div v-show="!haveSearchList">
        <p class="title">常用</p>
        <div class="Countrylist">
          <div
            v-for="(item, index) in hotCountry"
            :key="index"
            class="countrycode-item"
            @click="chooseCountry(item)"
          >
            <div class="itemName">
              <getFlagDom v-if="isShowFlagDom" :code="item.code" />
              <p>{{ item.name }}</p>
            </div>
            <p>{{ item.code }}</p>
          </div>
        </div>
        <div v-for="(item, idx) in allLetter" :key="idx">
          <p class="title">{{ item }}</p>
          <div class="Countrylist">
            <div
              v-for="(items, ind) in sortAllCountry[item]"
              :key="ind"
              class="countrycode-item"
              @click="chooseCountry(items)"
            >
              <div class="itemName">
                <getFlagDom v-if="isShowFlagDom" :code="items.code" />
                <p>{{ items.name }}</p>
              </div>
              <p>{{ items.code }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-show="haveSearchList">
        <div class="Countrylist">
          <div
            v-for="(items, ide) in searchCountryList"
            :key="ide"
            class="countrycode-item"
            @click="chooseCountry(items)"
          >
            <div class="itemName">
              <getFlagDom v-if="isShowFlagDom" :code="items.code" />
              <p>{{ items.name }}</p>
            </div>
            <p>{{ items.code }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import getFlagDom from './getFlagDom.vue';

export default {
  components: { getFlagDom },
  props: {
    getCountryInfo: {
      type: Function,
      default: () => {},
    },
    isShowFlagDom: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      checkTimer: '', //防抖
      CountryName: '',
      dialogVisible: false,
      haveSearchList: false,
      // 热门国家
      hotCountry: [],
      // 所有字母
      allLetter: [],
      // 根据字母分类的国家
      sortAllCountry: {},
      allCountry: [],
      searchCountryList: [],
    };
  },
  async mounted() {
    // 赋值
    axios.get('https://res.miaocode.com/country/country.json').then(res => {
      // FIXME 加拿大与美国共享区号+1，这个组件在很多地方都有用到，加入国旗后，会造成加拿大国旗变成+1（美国国旗）；
      // 可以在其他用到这个组件的地方，返回值增加code,name对象； 不过估计不太行 太多了
      // 暂时把加拿大去掉

      this.allCountry = res.data.allCountry.filter(item=>{return item.name!='加拿大'});
      const allCountryRes = res.data.allCountry;
      this.sortAllCountry = res.data.sortAllCountry;
      this.hotCountry = res.data.hotCountry.filter(item=>{return item.name!='加拿大'});
      this.allLetter = Object.keys(res.data.sortAllCountry);
    });
  },
  methods: {
    // 搜索
    check() {
      if (this.checkTimer != null) {
        clearTimeout(this.checkTimer);
      }
      this.checkTimer = setTimeout(() => {
        if (this.CountryName === '') {
          this.haveSearchList = false;
          return;
        }
        this.searchCountryList = [];
        this.allCountry.forEach(item => {
          if (item.name.indexOf(this.CountryName) !== -1) {
            this.searchCountryList.push(item);
          }
        });
        console.log(this.searchCountryList);
        this.haveSearchList = true;
      }, 300);
    },
    chooseCountry(item) {
      this.getCountryInfo(item);
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.Countryselect {
  position: absolute;
  width: 100%;
  height: 100%;
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 2;
  }
  &-inner {
    z-index: 9998;
    overflow-y: auto;
    height: 85%;
    position: fixed;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    width: 100%;
    border-radius: 0.9375rem 0.9375rem 0 0;
    background-color: #f5f5f5;
    text-align: left;
    font-size: 1rem;
    .Countrylist {
      background: white;
      padding: 0 1rem;
      .countrycode-item {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #e4e4e4;

        .itemName {
          display: flex;
          align-items: center;
        }
      }
    }
  }
  .top {
    padding: 0 1rem;
    position: relative;
    margin-bottom: 0.625rem;
    img {
      position: absolute;
      height: 1.4rem;
      top: 50%;
      left: 1.5rem;
      z-index: 9999;
      transform: translateY(-50%);
    }
    .input {
      width: 90%;
      height: 2.2rem;
      padding-left: 2.6rem;
      border: none;
      position: relative;
      left: 50%;
      transform: translate(-50%);
      font-size: 1rem;
      outline: 0;
    }
  }

  .title {
    text-align: left;
    font-size: 1.1rem;
    font-weight: bold;
    background-color: #f5f5f5;
    padding: 0 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/country-select/country-select.vue